module.exports = __webpack_public_path__ + "static/media/xc6.e39b6c6a.jpeg";